module.exports = __webpack_public_path__ + "files/7f3986c7a7d6634ed5a1d05d350cc6f6.png";